var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPercent = function SvgPercent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 133.4C0 59.8 59.8 0 133.3 0s133.4 59.8 133.4 133.4c0 73.5-59.8 133.4-133.4 133.4C59.8 266.7 0 206.9 0 133.4M990.3 19.7l-12-12c-10.6-10.6-28.3-10.2-39.4.9L8.7 938.8C3.3 944.2.2 951.2 0 958.6c-.2 7.5 2.5 14.5 7.7 19.7l12 12c5.1 5.1 12 7.7 18.9 7.7 7.4 0 14.9-2.9 20.6-8.6L989.4 59.2c11.1-11.2 11.5-28.9.9-39.5M998 864.6c0 73.5-59.8 133.4-133.4 133.4s-133.4-59.8-133.4-133.4c0-73.5 59.8-133.4 133.4-133.4S998 791.1 998 864.6"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPercent);
export default ForwardRef;